import { render } from "./App.vue?vue&type=template&id=16ce07ae"
const script = {}

import "./App.vue?vue&type=style&index=0&id=16ce07ae&lang=scss"
script.render = render

export default script